import React, { useState } from "react";
import { Grid, Slider, Typography, Box, TextField } from "@mui/material";
import isObjectEmpty from "helpers/isObjectEmpty";
import { CustomColumn } from "../..";
import { filterFieldStyles } from "./styling";

const SingleRangeFilter = ({
  range,
  label,
  filters,
  setFilters,
  customColumns,
}: {
  range: number[];
  label: string;
  filters: Record<string, any>;
  setFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  customColumns: CustomColumn;
}) => {
  const [value, setValue] = useState<number[]>(
    filters[label]?.keywords || range
  );
  const customColumnsExist = customColumns && !isObjectEmpty(customColumns);
  
  const handleChange = (_event: Event, newValue: number | number[]) => {
    setValue(newValue as number[]);
    setFilters((prev) => {
      return {
        ...prev,
        [label]: {
          comparator: "till",
          keywords: newValue,
        },
      };
    });
  };

  const minValue = value[0] || range[0];
  const maxValue = value[1] || range[1];

  return (
    <Box sx={filterFieldStyles.container}>
      <Typography variant="subtitle2" sx={filterFieldStyles.label}>
        {customColumnsExist && customColumns?.[label]?.[label]
          ? customColumns?.[label]?.[label]
          : label}
      </Typography>
      <Box sx={filterFieldStyles.rangeContainer}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Slider
              value={value}
              onChange={handleChange}
              valueLabelDisplay="auto"
              min={range[0]}
              max={range[1]}
              sx={{
                width: "100%",
                '& .MuiSlider-thumb': {
                  height: 18,
                  width: 18,
                },
                '& .MuiSlider-track': {
                  height: 6
                },
                '& .MuiSlider-rail': {
                  height: 6
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField 
              value={minValue}
              variant="outlined"
              size="small"
              disabled
              fullWidth
              InputProps={{
                sx: { fontSize: "0.875rem" }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField 
              value={maxValue}
              variant="outlined"
              size="small"
              disabled
              fullWidth
              InputProps={{
                sx: { fontSize: "0.875rem" }
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SingleRangeFilter;
